// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
/**
 * DPDPA compliance mark.
 *
 * `compactOnMobile` drops the label to the shield alone on phones, for the one
 * place it shares a cramped header row with a title and a Logout button. It is
 * opt-in because everywhere else the Badge either stands alone (login, consent)
 * or has room, and a lone emoji there would read as noise. The full text stays
 * in the accessible name either way.
 */
export function Badge({ compactOnMobile = false }: { compactOnMobile?: boolean }) {
  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-bold text-brand-600 bg-brand-50 border border-brand-200 py-0.5 rounded-full shrink-0 ${compactOnMobile ? "px-1.5 sm:px-2" : "px-2"}`}
      title="DPDPA compliant"
      aria-label="DPDPA compliant"
    >
      <span aria-hidden="true">🛡</span>
      <span className={compactOnMobile ? "hidden sm:inline" : undefined}>DPDPA</span>
    </span>
  );
}
